// angular
//   .module('HeroPRO')
//   .factory('FRInformationFactory', fundingRequestInformationFactory);

import _ from 'lodash';

/* @ngInject */
export default function fundingRequestInformationFactory(HPConfig, DealTypeFactory, $http, $q, $stateParams) {
    let _fundingRequestInformationPromise;
    let _stateMachineData = {};
    let _appInfo = {};
    let _financialDocuments = {};
    let _planInformation = {};

    return {
        getFundingRequestInformation,
        getFundingRequestInformationPromise,
        getPlanInformation,
        getPlanInformationData,
        getAppInfo,
        getFinancialDocuments,
        getStateMachineData,
        setStateMachineData,
        setPlanTermData,
        getRequiredDocGenSetType
    };

    function getRequiredDocGenSetType() {
        return $http.get(`${HPConfig.heroProApi}Loan/FundingRequest/RequiredDocGenSetType?FundingRequestId=${$stateParams.appId}`)
            .then((response) => {
                return response.data.Data;
            });
    }

    function getFundingRequestInformation() {
        resetFundingRequestInformation();
        _fundingRequestInformationPromise = $q((resolve) => {
            $http.get(`${HPConfig.heroProApi}Loan/FundingRequest/Pipeline/${$stateParams.appId}`).then((response) => {
                setAppInfo(response.data.Data.AppDetail);
                setDealType(response.data.Data.AppDetail);
                setStateMachineData(_appInfo.PipelineStageId, _appInfo.FundingRequestPipelineStageId, _appInfo.LoanStateId, _appInfo.FundingRequestStateId, _appInfo.CompletionCertificateStateId, getACAStateId(), _appInfo.FinDocsStateId);
                _financialDocuments = response.data.Data.FinancialDocuments;
                resolve();
            });
        });
        return _fundingRequestInformationPromise;
    }

    function getFundingRequestInformationPromise() {
        return _fundingRequestInformationPromise;
    }

    function resetFundingRequestInformation() {
        _stateMachineData = {};
        _appInfo = {};
        _financialDocuments = {};
    }

    function getPlanInformation() {
        const params = {
            planId: _appInfo.PlanId,
            planTermSetId: _appInfo.PlanTermSetId,
            termSetId: _appInfo.TermSetId,
        };

        return $http.get(`${HPConfig.heroProApi}Plan`, { params }).then((response) => {
            setPlanInformation(response.data.Data);
        });
    }

    function setPlanInformation(data) {
        _planInformation = data;
    }

    function getPlanInformationData() {
        return _planInformation;
    }

    function setAppInfo(data) {
        _appInfo = data;
        _appInfo.isCountersigned = _appInfo.CountersignedDate !== undefined && _appInfo.CountersignedDate !== null && _appInfo.CountersignedDate !== '';
        _appInfo.isIssuerReviewed = _appInfo.IssuerReviewedDate !== undefined && _appInfo.IssuerReviewedDate !== null && _appInfo.IssuerReviewedDate !== '';
        _appInfo.isNTPSent = _appInfo.NoticeToProceedSentDate !== undefined && _appInfo.NoticeToProceedSentDate !== null && _appInfo.NoticeToProceedSentDate !== '';
        _appInfo.isNTPLate = (_appInfo.IsNoticeToProceedLate !== undefined) ? _appInfo.IsNoticeToProceedLate : false;
    }

    function setDealType(data) {
        DealTypeFactory.setSelectedDealType(data.DealType);
    }

    function getAppInfo() {
        return _appInfo;
    }

    function setStateMachineData(newPipelineStageId, newFundingRequestPipelineStageId, newLoanStateId, newFundingRequestStateId, newCompletionCertificateStateId, newACAStateId, newFinDocsStateId) {
        _stateMachineData.PipelineStageId = newPipelineStageId;
        _stateMachineData.LoanStateId = newLoanStateId;

        if (newFundingRequestPipelineStageId !== undefined) {
            _stateMachineData.FundingRequestPipelineStageId = newFundingRequestPipelineStageId;
        }
        if (newFundingRequestStateId !== undefined) {
            _stateMachineData.FundingRequestStateId = newFundingRequestStateId;
        }
        if (newCompletionCertificateStateId !== undefined) {
            _stateMachineData.CompletionCertificateStateId = newCompletionCertificateStateId;
        }
        if (newACAStateId !== undefined) {
            _stateMachineData.ACAStateId = newACAStateId;
        }
        if (newFinDocsStateId !== undefined) {
            _stateMachineData.FinDocsStateId = newFinDocsStateId;
        }
    }

    function getStateMachineData() {
        return _stateMachineData;
    }

    function getACAStateId() {
        return !!_appInfo.AssessmentContractAddendums && _appInfo.AssessmentContractAddendums.length > 0 ?
            _.max(_appInfo.AssessmentContractAddendums, addendum =>
                // Take the most recent ACA
                Date.parse(addendum.CreatedDate)).AssessmentContractAddendumStateId : 0;
    }

    function getFinancialDocuments() {
        return _financialDocuments;
    }

    function setPlanTermData(newPlanTermData) {
        _appInfo.PlanId = newPlanTermData.PlanId;
        _appInfo.PlanTermSetId = newPlanTermData.PlanTermSetId;
        _appInfo.TermSetId = newPlanTermData.TermSetId;
    }
}



// WEBPACK FOOTER //
// ./src/app/appDetail/fundingRequestInformationFactory.js